module.exports = __webpack_public_path__ + "static/img/7.7431e30.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/1/zh/7.png
// module id = a9Qs
// module chunks = 0